import {Component, Input} from '@angular/core';
import {ProjectReferenceSearchResponse} from '../../models/project-reference-search-response';

@Component({
    selector: 'app-project-reference-grid',
    templateUrl: './project-reference-grid.component.html',
    standalone: false
})
export class ProjectReferenceGridComponent {
    @Input() projectReferences: ProjectReferenceSearchResponse[] | null = [];

    trackByFn(index: number, ref: ProjectReferenceSearchResponse) {
        return ref.id
    }
}
